import { useState, useEffect } from "react";
import ProgrammerMen from "../../assets/home/programmer.png";
import ScrollArrow from "../../components/ScrollArrow";
import "./Home.css";

const Home = () => {
  const [typedText, setTypedText] = useState("");
  const text =
    "Meu foco é ajudar empresas a transmitirem sua mensagem, construindo experiências digitais modernas e de alta qualidade!";
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentIndex < text.length) {
        setTypedText((prevText) => prevText + text[currentIndex]);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      } else {
        clearInterval(interval);
      }
    }, 50);

    // Adicionar um atraso de 2000 milissegundos (2 segundos)
    const delay = setTimeout(() => {
      clearInterval(interval); // Limpa o intervalo inicial, para que a animação comece após o atraso
    }, 2000);

    return () => {
      clearTimeout(delay);
      clearInterval(interval);
      // Limpa o atraso ao desmontar o componente
    };
  }, [currentIndex, text]);
  return (
    <div id="home" className="home">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
      <div id="home" className="mainHome">
        <div className="mainText">
          <h1>João Carvalho </h1>
          <div className="typing-animation">
            <h2>{typedText}</h2>
          </div>
        </div>
        <div className="mainImage">
          <img
            src={ProgrammerMen}
            alt="Imagem cartunizada de progamador com seu notebook"
          />
        </div>
      </div>
      <div className="bottomHome">
        <ScrollArrow />
      </div>
    </div>
  );
};
export default Home;
